import React from 'react'
import { Div, Spacer, Text } from '@sendoutcards/quantum-design-ui'
// @src imports
import { useAccount } from 'src/hooks'
import { getPlan } from 'src/helpers'
import {
  mobilePricingTableData,
  pricingTableData,
} from 'src/redux/selectors/plans'
import {
  MobilePricingTable,
  PricingTable,
} from 'src/marketing/plans/components'
import plansInfo, { enabledPlans } from 'src/marketing/plans/plansInfo'
import AnnouncementBanners from 'src/marketing/AnnouncementBanners/AnnouncementBanners'

const styles = {
  plansContainer: {
    width: '100%',
    fontFamily: "'Open Sans', sans-serif",
  },
  planCopy: {
    maxWidth: '1050px',
    textAlign: 'center' as const,
    margin: '0 auto',
    '@media (max-width: 1025px)': {
      padding: '20px 30px 0',
      textAlign: 'left' as const,
      marginBottom: '0',
    },
  },
  pricingTable: {
    background: '#f7f7f7',
    marginBottom: '50px',
  },
  pricingTableContainer: {
    width: '80%',
    margin: 'auto',
    marginBottom: '15px',
    '&.mobileTable': {
      display: 'none',
    },
    '@media (max-width: 1260px)': {
      width: '95% !important',
    },
    '@media (max-width: 1060px)': {
      '&.mobileTable': {
        padding: '25px',
        display: 'inherit',
      },
      '&.desktopTable': {
        display: 'none',
      },
    },
  },
}

const pricingInfo = pricingTableData(
  plansInfo.categories,
  plansInfo.features,
  enabledPlans,
)

const mobilePricingInfo = mobilePricingTableData(
  plansInfo.categories,
  plansInfo.features,
  enabledPlans,
)

interface Props {
  title?: string
  message?: string
  onSelect: (title: string, isKeepButton?: boolean) => void
}

const Plans: React.FC<Props> = props => {
  const {
    title = 'Upgrade your life today.',
    message = 'We have the perfect subscription for everyone, no matter how you choose to use SendOutCards. Start making a difference by choosing the plan that will work best for you. If you change your mind later, no worries — you can always switch plans or cancel.',
    onSelect,
  } = props

  const account = useAccount()

  const tableProps = {
    account: account,
    stripeSubscription: account.stripeSubscription || undefined,
    onSelect: onSelect,
    getPlan: (id: string) => getPlan(enabledPlans, id),
  }

  return (
    <Div css={styles.plansContainer}>
      <AnnouncementBanners />
      <Div css={styles.planCopy}>
        <Spacer space="x2" />
        <Text type="subtitle" alignment="center">
          {title}
        </Text>
        <Spacer space="x2" />
        <Text type="body" alignment="center">
          {message}
        </Text>
      </Div>
      <Spacer space="x6" />
      <Div css={styles.pricingTable}>
        <Div css={styles.pricingTableContainer} className={'desktopTable'}>
          <PricingTable
            {...tableProps}
            categories={pricingInfo}
            plans={enabledPlans}
          />
        </Div>
        <Div css={styles.pricingTableContainer} className={'mobileTable'}>
          <MobilePricingTable {...tableProps} plans={mobilePricingInfo} />
        </Div>
      </Div>
    </Div>
  )
}

export default Plans
